import { Link } from 'react-router-dom';

function UnUniversity() {
  return (
    <div className="page-shell">
      <div className="page-intro" style={{ background: 'linear-gradient(135deg, rgba(12, 47, 77, 0.08) 0%, rgba(0, 158, 219, 0.12) 100%)', borderRadius: '20px', padding: '32px' }}>
        <span style={{ background: '#0c2f4d', color: '#f9c84a', padding: '3px 12px', borderRadius: '12px', fontSize: '0.78rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Global Education Initiative
        </span>
        <h1 className="page-title" style={{ marginTop: '12px', color: '#0c2f4d' }}>UN University for Global Peace</h1>
        <p className="page-subtitle">
          Promoting peace education, international cooperation, conflict resolution, and sustainable solutions for human security worldwide.
        </p>
      </div>

      <div className="content-wrap contact-layout" style={{ marginTop: '32px' }}>
        <section className="content-panel">
          <h3 style={{ color: '#0c2f4d', marginTop: 0 }}>Mission & Academic Vision</h3>
          <p>
            Through rigorous research, leadership training, and multi-stakeholder advocacy, the UN University for Global Peace
            strengthens global understanding, conflict prevention, and long-term pathways toward social stability and human dignity.
          </p>

          <h3 style={{ color: '#0c2f4d', marginTop: '28px' }}>Core Academic Pillars</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginTop: '16px' }}>
            <div style={{ background: '#f4f8fc', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #009edb' }}>
              <h4 style={{ margin: '0 0 8px', color: '#0c2f4d' }}>🕊️ Peace & Conflict Resolution</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#405a73' }}>
                Mediation techniques, diplomatic negotiation, and sustainable peace-building in post-conflict zones.
              </p>
            </div>
            <div style={{ background: '#f4f8fc', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #4C9F38' }}>
              <h4 style={{ margin: '0 0 8px', color: '#0c2f4d' }}>🌍 Global SDG Leadership</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#405a73' }}>
                Integrating the 17 UN Sustainable Development Goals into local policy, governance, and community development.
              </p>
            </div>
            <div style={{ background: '#f4f8fc', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #f9c84a' }}>
              <h4 style={{ margin: '0 0 8px', color: '#0c2f4d' }}>📜 Human Rights & Social Justice</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#405a73' }}>
                Advocating Universal Declaration of Human Rights principles across civil society and international law.
              </p>
            </div>
          </div>
        </section>

        <aside>
          <div className="info-card" style={{ marginBottom: '20px' }}>
            <h3 style={{ color: '#0c2f4d', margin: '0 0 12px' }}>Academic Outreach</h3>
            <p style={{ fontSize: '0.9rem', color: '#405a73', margin: '0 0 14px' }}>
              Programs are open to diplomats, NGO directors, community leaders, and students passionate about global development.
            </p>
            <Link to="/contact" className="primary-button" style={{ width: '100%', textAlign: 'center', display: 'block' }}>
              Inquire About Programs
            </Link>
          </div>
        </aside>
      </div>
    </div>
  );
}

export default UnUniversity;
